document.addEventListener('DOMContentLoaded', () => {
  let currentCups = 1;

  const calculator = document.querySelector('.coffee-calculator');
  if (!calculator) return;

  const launcher = calculator.querySelector('.coffee-calculator-launcher');
  const triggerBtn = calculator.querySelector('.coffee-launcher-button');
  const recommendedBlock = calculator.querySelector('.recommended-subscriptions');

  const modal = calculator.querySelector('.coffee-modal');
  const overlay = calculator.querySelector('.coffee-modal-overlay');
  const closeBtn = calculator.querySelector('.coffee-modal-close');

  const slider = calculator.querySelector('.coffee-range');
  const cupCount = calculator.querySelector('.cup-count');
  const dailyOz = calculator.querySelector('.daily-oz');
  const bagPreview = calculator.querySelector('.bag-preview');
  const savedIcon = calculator.querySelector('.saved-icon');

  const recommendationContainer = calculator.querySelector('.recommendation-slider');

  const bag12oz = calculator.dataset.bagTwelveOz;
  const bag2x12oz = calculator.dataset.bagTwoTwelveOz;
  const bag25lb = calculator.dataset.bagTwentyfiveLb;
  const bag2x25lb = calculator.dataset.bagTwoTwentyfiveLb;
  const bagCombo = calculator.dataset.bagCombo;

  const editBtn = calculator.querySelector('.coffee-edit-intake');

  const subscriptionOptions = {
  1: [
    { image: bag12oz, qtyLabel: '12oz bag', frequency: 'every 3 weeks' },
    { image: bag2x12oz, qtyLabel: 'two 12oz bags', frequency: 'every 1 month' },
    { image: bag25lb, qtyLabel: '2.5lb bag', frequency: 'every 1 month' }
  ],

  2: [
    { image: bag12oz, qtyLabel: '12oz bag', frequency: 'every 2 weeks' },
    { image: bag2x12oz, qtyLabel: 'two 12oz bags', frequency: 'every 3 weeks' },
    { image: bag25lb, qtyLabel: '2.5lb bag', frequency: 'every 1 month' }
  ],

  3: [
    { image: bag2x12oz, qtyLabel: 'two 12oz bags', frequency: 'every 3 weeks' },
    { image: bagCombo, qtyLabel: '12oz + 2.5lb', frequency: 'every 1 month' },
    { image: bag25lb, qtyLabel: '2.5lb bag', frequency: 'every 4 weeks' }
  ],

  4: [
    { image: bag2x12oz, qtyLabel: 'two 12oz bags', frequency: 'every 2 weeks' },
    { image: bag25lb, qtyLabel: '2.5lb bag', frequency: 'every 3 weeks' }
  ],

  5: [
    { image: bag2x12oz, qtyLabel: 'two 12oz bags', frequency: 'every 2 weeks' },
    { image: bag2x25lb, qtyLabel: 'two 2.5lb bags', frequency: 'every 1 month' }
  ],

  6: [
    { image: bag25lb, qtyLabel: '2.5lb bag', frequency: 'every 2 weeks' },
    { image: bag2x25lb, qtyLabel: 'two 2.5lb bags', frequency: 'every 4 weeks' }
  ],

  7: [
    { image: bag2x25lb, qtyLabel: 'two 2.5lb bags', frequency: 'every 3 weeks' }
  ],

  8: [
    { image: bag2x25lb, qtyLabel: 'two 2.5lb bags', frequency: 'every 2 weeks' }
  ],

  9: [
    { image: bag2x25lb, qtyLabel: 'two 2.5lb bags', frequency: 'every 2 weeks' }
  ],

  10: [
    { image: bag2x25lb, qtyLabel: 'two 2.5lb bags', frequency: 'every 2 weeks' }
  ]
};

  function initializeView() {
    const savedCups = parseInt(localStorage.getItem('coffeeCalculator'));

    if (savedCups && subscriptionOptions[savedCups]) {
      launcher.classList.add('hidden');
      recommendedBlock.classList.remove('hidden');

      currentCups = savedCups;
      slider.value = savedCups;

      updateCalculator(savedCups);
      renderRecommendations(savedCups);
    } else {
      launcher.classList.remove('hidden');
      recommendedBlock.classList.add('hidden');

      updateCalculator(1);
    }
  }

  function openModal() {
    modal.classList.remove('hidden');
    overlay.classList.remove('hidden');
  }

  function closeModal() {
    modal.classList.add('hidden');
    overlay.classList.add('hidden');
  }

  function updateCalculator(cups) {
    cupCount.textContent = cups;
    dailyOz.textContent = cups * 10;

    const recs = subscriptionOptions[cups] || [];

    bagPreview.innerHTML = recs.map(rec => `
      <div class="bag-graphic">
        <img
          src="${rec.image}"
          alt="${rec.qtyLabel}"
          class="bag-graphic-image"
        >
        <div class="bag-qty">${rec.qtyLabel}</div>
        <p class="caption-with-letter-spacing">${rec.frequency}</p>
      </div>
    `).join('');
  }

function renderRecommendations(cups) {
  const recs = subscriptionOptions[cups] || [];
  const sliderWrapper = calculator.querySelector('.coffee-recommendation-slider');
  const track = recommendationContainer;

  if (!track || !sliderWrapper || !recs.length) return;

  const prevBtn = sliderWrapper.querySelector('.slider-button--prev');
  const nextBtn = sliderWrapper.querySelector('.slider-button--next');

  /*
   SINGLE RECOMMENDATION
   -----------------------------------
   No slider behavior, no arrows
  */
  if (recs.length === 1) {
    track.innerHTML = `
      <li class="recommendation-card slider__slide grid__item">
        <img src="${recs[0].image}" alt="${recs[0].qtyLabel}" class="recommendation-image">
        <div class="group">
          <div class="rec-qty">${recs[0].qtyLabel}</div>
          <p class="caption-with-letter-spacing">${recs[0].frequency}</p>
        </div>
      </li>
    `;

    prevBtn.classList.add('hidden');
    nextBtn.classList.add('hidden');

    track.style.scrollBehavior = 'auto';
    track.onscroll = null;
    prevBtn.onclick = null;
    nextBtn.onclick = null;

    launcher.classList.add('hidden');
    recommendedBlock.classList.remove('hidden');
    return;
  }

  /*
   MULTIPLE RECOMMENDATIONS
   -----------------------------------
   Looping slider
  */
  prevBtn.classList.remove('hidden');
  nextBtn.classList.remove('hidden');

  const loopedRecs = [
    recs[recs.length - 1],
    ...recs,
    recs[0]
  ];

  track.innerHTML = loopedRecs.map((rec, index) => `
    <li class="recommendation-card slider__slide grid__item" id="Slide-${index}">
      <img src="${rec.image}" alt="${rec.qtyLabel}" class="recommendation-image">
      <div class="group">
        <div class="rec-qty">${rec.qtyLabel}</div>
        <p class="caption-with-letter-spacing">${rec.frequency}</p>
      </div>
    </li>
  `).join('');

  const slides = track.querySelectorAll('.recommendation-card');
  const slideWidth = slides[0].offsetWidth;

  let currentIndex = 1;
  let isJumping = false;

  track.style.scrollBehavior = 'auto';
  track.scrollLeft = slideWidth;

  requestAnimationFrame(() => {
    track.style.scrollBehavior = 'smooth';
  });

  function goToSlide(index) {
    if (isJumping) return;

    currentIndex = index;

    track.scrollTo({
      left: slideWidth * currentIndex,
      behavior: 'smooth'
    });
  }

  nextBtn.onclick = () => {
    goToSlide(currentIndex + 1);
  };

  prevBtn.onclick = () => {
    goToSlide(currentIndex - 1);
  };

  track.onscroll = () => {
    if (isJumping) return;

    const scrollLeft = track.scrollLeft;

    // fake first clone
    if (scrollLeft >= slideWidth * (slides.length - 1) - 5) {
      isJumping = true;

      track.style.scrollBehavior = 'auto';
      currentIndex = 1;
      track.scrollLeft = slideWidth;

      requestAnimationFrame(() => {
        track.style.scrollBehavior = 'smooth';
        isJumping = false;
      });
    }

    // fake last clone
    if (scrollLeft <= 5) {
      isJumping = true;

      track.style.scrollBehavior = 'auto';
      currentIndex = slides.length - 2;
      track.scrollLeft = slideWidth * currentIndex;

      requestAnimationFrame(() => {
        track.style.scrollBehavior = 'smooth';
        isJumping = false;
      });
    }
  };

  launcher.classList.add('hidden');
  recommendedBlock.classList.remove('hidden');
}

  function setCups(cups, skipRender = false) {
    currentCups = cups;
    slider.value = cups;

    updateCalculator(cups);

    if (!skipRender) {
      renderRecommendations(cups);
    }
  }

  triggerBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  slider.addEventListener('input', () => {
    const cups = parseInt(slider.value);

    setCups(cups);

    localStorage.setItem('coffeeCalculator', cups);

    savedIcon.classList.remove('hidden');

    setTimeout(() => {
      savedIcon.classList.add('hidden');
    }, 1200);
  });

  if (editBtn) {
    editBtn.addEventListener('click', () => {
      const savedCups = parseInt(localStorage.getItem('coffeeCalculator') || 1);

      setCups(savedCups, true);
      openModal();
    });
  }

  initializeView();
});
